import { List, Stack } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { NoResults } from "lib/@components/no-results/no-results"
import { MacroGuidanceListItem } from "./macro-guidance-list-item"

export function MacroGuidanceList({ macros = [], selectedId, onOpen, emptyMessage = "No macros.", maxHeight = 345 }) {
    return (
        <Stack sx={{ maxHeight, overflowY: "auto" }}>
            <If truthy={macros.length > 0}>
                <List disablePadding sx={{ display: "grid", gap: 0.5 }}>
                    <Repeat
                        list={macros}
                        pass="macro"
                        keyFn="id"
                        item={<MacroGuidanceListItem selectedId={selectedId} onOpen={onOpen} />}
                    />
                </List>
                <Else>
                    <NoResults mt={0} width={220}>
                        {emptyMessage}
                    </NoResults>
                </Else>
            </If>
        </Stack>
    )
}
